export const DEFAULT_CLASSIFICATION_ID = "3f5d5e32-e963-49a6-b89a-3fb3770d45c8";
export const DEFAULT_CLASSIFICATION_NAME = "Me";
